/**
 * @generated SignedSource<<6deec0b25f69d44d25f5aac831bd2db2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type ImageVersionTypeName = "bgProcessed" | "datamatics" | "large" | "master" | "medium" | "oldMaster" | "original" | "placeholder" | "small" | "thumb" | "transparent" | "zoom" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type PdpHead_item$data = {
  readonly isPriceUponRequest: boolean | null;
  readonly localizedPdpUrl: string | null;
  readonly microdata: string | null;
  readonly microdataWithImageObj: string | null;
  readonly pdpMeta: {
    readonly description: string | null;
    readonly index: boolean | null;
    readonly ogTitle: string | null;
    readonly productPriceAmount: string | null;
    readonly productPriceCurrency: string | null;
    readonly title: string | null;
  } | null;
  readonly pdpURL: string | null;
  readonly photos: ReadonlyArray<{
    readonly versions: ReadonlyArray<{
      readonly type: {
        readonly name: ImageVersionTypeName | null;
      } | null;
      readonly webPath: string | null;
    } | null> | null;
  } | null> | null;
  readonly " $fragmentType": "PdpHead_item";
};
export type PdpHead_item$key = {
  readonly " $data"?: PdpHead_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpHead_item">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "currency",
  "variableName": "forcedCurrency"
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "forcedCurrency"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpHead_item",
  "selections": [
    {
      "alias": null,
      "args": [
        (v0/*: any*/)
      ],
      "kind": "ScalarField",
      "name": "microdata",
      "storageKey": null
    },
    {
      "alias": "microdataWithImageObj",
      "args": [
        {
          "kind": "Literal",
          "name": "addImageObj",
          "value": true
        },
        (v0/*: any*/)
      ],
      "kind": "ScalarField",
      "name": "microdata",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pdpURL",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "localizedPdpUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "pdpMetaItems",
      "kind": "LinkedField",
      "name": "pdpMeta",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "index",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "description",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "ogTitle",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "productPriceAmount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "productPriceCurrency",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemPhoto",
      "kind": "LinkedField",
      "name": "photos",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ItemPhotoVersion",
          "kind": "LinkedField",
          "name": "versions",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "webPath",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "ImageVersionType",
              "kind": "LinkedField",
              "name": "type",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isPriceUponRequest",
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};
})();

(node as any).hash = "db607403aba86a7e79911d155d44b1cb";

export default node;
